import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRole } from '../redux/Roles/actions';
import { fetchOverride } from '../redux/Overrides/actions';

const useUserCapabilities = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const role = useSelector((state) => state.roles.role);
  const override = useSelector((state) => state.overrides.override);
  
  const [resourceIds, setResourceIds] = useState([]);
  const [capabilityIds, setCapabilityIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setIsLoading(true); // Start loading
      const fetchData = async () => {
        if (user.role) {
          await dispatch(fetchRole(user.role._id));
        }
        if (user.override && user.override.length > 0) {
          await dispatch(fetchOverride(user.override[0]._id));
        }
        setIsLoading(false); // Stop loading once data is fetched
      };
      fetchData();
    }
  }, [user, dispatch]);

  useEffect(() => {
    const newResourceIds = new Set();
    const newCapabilityIds = new Set();

    if (role) {
      role.defaultRessources?.forEach((resource) => newResourceIds.add(resource));
      role.defaultCapabilities?.forEach((capability) => newCapabilityIds.add(capability));
    }

    if (override) {
      override.defaultRessources?.forEach((resource) => newResourceIds.add(resource));
      override.defaultCapabilities?.forEach((capability) => newCapabilityIds.add(capability));
    }

    setResourceIds(Array.from(newResourceIds));
    setCapabilityIds(Array.from(newCapabilityIds));
  }, [role, override]);

  const hasResource = (resourceName) => {
    if (isLoading) return false;
    return resourceIds.some(resource => resource.name === resourceName) || 
           resourceIds.some(resource => resource.name === 'all');
  };

  const hasCapability = (capabilityName) => {
    if (isLoading) return false;
    return capabilityIds.some(capability => capability.name === capabilityName) || 
           capabilityIds.some(capability => capability.name === 'all');
  };

  return { hasResource, hasCapability, isLoading };
};

export default useUserCapabilities;
